// Mock data for A To Z Infraspares Landing Page

export const heroData = {
  headline: "India's Trusted Supplier of Earthmoving & Mining Spares",
  subheadline: "20+ Years | Genuine & Aftermarket Parts | Fast Pan-India Delivery",
  description: "Reduce machine downtime with reliable, ready-stock spare parts for JCB, Excavators, Loaders & Heavy Equipment.",
  ctaText: "Get Instant Quote",
  secondaryCtaText: "Call Now",
  trustLine: "Serving 1000+ Contractors, Fleet Owners & Dealers Across India",
  heroImage: "/hero-quarry.png"
};

export const coreBenefitsData = {
  title: "Everything You Need to Keep Your Machines Running",
  benefits: [
    "✔ Genuine & High-Quality Aftermarket Parts",
    "✔ Wide Range: Engine, Hydraulic, Filters, Undercarriage & More",
    "✔ Ready Stock for Fast Dispatch",
    "✔ Competitive Pricing Without Compromise",
    "✔ Expert Support for Part Identification"
  ]
};

export const whoWeServeData = {
  title: "Built for Businesses That Can't Afford Downtime",
  subtitle: "Whether you're running a construction site, managing a fleet, or operating a mining facility, equipment downtime costs you thousands per hour. We understand the pressure you face every day.",
  segments: [
    {
      icon: "Hammer",
      title: "For Contractors",
      description: "Get the parts you need delivered fast to minimize site delays. From JCB to excavators, we stock what you use most. No waiting weeks for critical components."
    },
    {
      icon: "Truck",
      title: "For Fleet Owners",
      description: "Keep your entire fleet operational with our comprehensive inventory. Volume discounts available. Dedicated account manager for quick reordering and technical support."
    },
    {
      icon: "Store",
      title: "For Equipment Dealers",
      description: "Consistent inventory support to grow your parts business. Competitive dealer pricing, fast fulfillment, and technical documentation to help your customers quickly."
    },
    {
      icon: "Mountain",
      title: "For Mining Companies",
      description: "Heavy-duty parts built for extreme conditions. From conveyor systems to crusher components, we supply the durability and performance your operation demands."
    }
  ]
};

export const productCategoriesData = {
  title: "Complete Range of Earthmoving Spare Parts",
  categories: [
    "Excavator Spare Parts",
    "Backhoe Loader Parts",
    "Hydraulic Components",
    "Engine Parts",
    "Filters (Air, Oil, Fuel)",
    "Undercarriage Parts",
    "Lubricants",
    "Crusher Spares"
  ],
  ctaText: "Request Price"
};

export const whyChooseUsData = {
  title: "Why 1000+ Customers Trust Us",
  points: [
    {
      icon: "Award",
      text: "20+ Years Industry Experience"
    },
    {
      icon: "Package",
      text: "Large Ready Inventory"
    },
    {
      icon: "Truck",
      text: "Fast Dispatch Across India"
    },
    {
      icon: "Handshake",
      text: "Trusted Multi-Brand Supplier"
    },
    {
      icon: "Wrench",
      text: "Expert Technical Support"
    },
    {
      icon: "IndianRupee",
      text: "Best Value Pricing"
    }
  ]
};

export const brandsData = {
  title: "World-Class Engineering for Maximum Durability",
  description: "We partner with the industry's most trusted names to ensure your machinery handles the toughest terrains and heaviest loads.",
  brands: [
    {
      name: "JM3",
      logo: "/logos/jm3.png",
      tagline: "PERFORMANCE MATTERS",
      specialization: "Elite Spherical Roller Bearings, specialized lubricants, and tooth points for heavy machinery.",
      categories: ["Bearings", "Lubricants", "Tooth Points"]
    },
    {
      name: "ITR",
      logo: "/logos/itr.png",
      tagline: "PASSION FOR PARTS",
      specialization: "Premium undercarriage, ground engaging tools, and hydraulic parts for all major earthmoving machinery.",
      categories: ["Undercarriage", "Ground Engaging Tools", "Hydraulic Parts"]
    },
    {
      name: "RIS",
      logo: "/logos/ris.png",
      tagline: "",
      specialization: "High-strength Conveyor Rollers and Frames built to last.",
      categories: ["Conveyor Rollers", "Frames"]
    },
    {
      name: "Q+",
      logo: "/logos/qplus.png",
      tagline: "The New Language of earth movers",
      specialization: "Advanced seal kits, rock breakers, rock buckets, and pin bushing solutions.",
      categories: ["Seal Kits", "Rock Breakers", "Pin Bushing"]
    },
    {
      name: "HINDUSTAN EAGLE",
      logo: null,
      tagline: "Conveyor Belting",
      specialization: "Ultra-durable, heavy-duty conveyor belts for extreme mining environments.",
      categories: ["Conveyor Belting"]
    },
    {
      name: "Donaldson",
      logo: "/logos/donaldson.png",
      tagline: "Filtration Solutions",
      specialization: "World-leading filtration solutions to protect your engines and extend equipment life.",
      categories: ["Filters"]
    },
    {
      name: "JK Fenner",
      logo: "/logos/jkfenner.png",
      tagline: "",
      specialization: "High-precision transmissions and Vee Belts for seamless power delivery.",
      categories: ["Transmission", "Vee Belts"]
    },
    {
      name: "Gates",
      logo: "/logos/gates.png",
      tagline: "",
      specialization: "Premium Hose Pipe and fittings for long lasting operations.",
      categories: ["Hose Pipe", "Fittings"]
    },
    {
      name: "Marathon Motors",
      logo: "/logos/marathon.png",
      tagline: "",
      specialization: "High performance industrial motor solutions.",
      categories: ["Industrial Motors"]
    },
    {
      name: "TVS",
      logo: "/logos/tvs.png",
      tagline: "",
      specialization: "Industrial fasteners and precision components for heavy equipment assembly.",
      categories: ["Fasteners"]
    },
    {
      name: "GROZ",
      logo: "/logos/groz.png",
      tagline: "",
      specialization: "Professional-grade tools and equipment for maintenance and servicing.",
      categories: ["Tools & Equipment"]
    }
  ]
};

export const socialProofData = {
  title: "Proven Performance You Can Rely On",
  description: "Real numbers from real businesses across India.",
  stats: [
    {
      icon: "Users",
      value: "1000+",
      label: "Happy Customers",
      description: "Contractors, dealers & fleet owners"
    },
    {
      icon: "Package",
      value: "50,000+",
      label: "Parts Supplied",
      description: "Keeping machines running"
    },
    {
      icon: "Award",
      value: "20+",
      label: "Years of Experience",
      description: "Trusted industry expertise"
    }
  ],
  reviewLink: "https://www.google.com/search?client=safari&rls=en&q=a+to+z+infraspares+pvt.+ltd.+reviews&ie=UTF-8&oe=UTF-8",
  backgroundImage: "https://images.pexels.com/photos/4487363/pexels-photo-4487363.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
};

export const testimonialsData = {
  title: "What Our Customers Say",
  testimonials: [
    {
      quote: "Quick response and genuine parts. Helped us reduce downtime significantly.",
      author: "Contractor, Delhi",
      rating: 5
    },
    {
      quote: "Reliable supplier with consistent stock availability.",
      author: "Equipment Dealer",
      rating: 5
    },
    {
      quote: "Best pricing without compromising on quality. Our go-to spare parts partner.",
      author: "Fleet Owner, Mumbai",
      rating: 5
    }
  ]
};

export const inventoryData = {
  title: "Strong Inventory. Faster Delivery.",
  description: "Our well-stocked warehouses and strong supplier network ensure you get the parts you need — when you need them.",
  responseTime: "⚡ Response within 30 minutes during working hours"
};

export const finalCTAData = {
  title: "Need Spare Parts Urgently?",
  description: "Get a quick quote and availability within minutes.",
  primaryCTA: "Request a Quote",
  secondaryCTA: "WhatsApp Us",
  responseTime: "⚡ Response within 30 minutes during working hours"
};

export const faqData = {
  title: "Frequently Asked Questions",
  faqs: [
    {
      question: "How quickly can you deliver spares to my site?",
      answer: "With 8 inventory locations across India, we offer some of the fastest turnaround times in the industry. Most common spares are available for immediate dispatch."
    },
    {
      question: "Do you supply both genuine and aftermarket parts?",
      answer: "Yes! We provide both genuine OEM parts and high-quality aftermarket alternatives, giving you the flexibility to choose based on your budget and requirements."
    },
    {
      question: "Which machines do you supply parts for?",
      answer: "We supply parts for all major earthmoving equipment including JCB, Excavators, Backhoe Loaders, Wheel Loaders, Dozers, Graders, and Stone Crushers."
    },
    {
      question: "How do I know which part is right for my specific machinery model?",
      answer: "Our team of 50+ technical experts can help identify the exact part number and specification for your specific make and model. Just share your machine details or part images."
    },
    {
      question: "What are your payment terms?",
      answer: "We offer flexible payment terms for regular customers. Contact our sales team for customized payment solutions based on your business needs."
    }
  ]
};

export const contactData = {
  companyName: "A To Z Infraspares Pvt Ltd",
  email: "enquiry@atozinfraspares.com",
  phone: "+91 94154 56760"
};

// Mock form submission handlers
export const handleQuoteRequest = (formData) => {
  console.log("Quote Request Submitted:", formData);
  return {
    success: true,
    message: "Thank you! We'll send you a quote within 24 hours."
  };
};

export const handleContactForm = (formData) => {
  console.log("Contact Form Submitted:", formData);
  return {
    success: true,
    message: "Thank you for contacting us! We'll get back to you soon."
  };
};

export const handleDownloadPortfolio = () => {
  console.log("Portfolio Download Requested");
  return {
    success: true,
    message: "Portfolio download will be available soon!"
  };
};
